import React from "react";
import styled from "styled-components";

import * as Color from "~/Color";
import * as Layout from "~/Layout";
import { Route as GenericRoute } from "~/Route";
import * as Shadow from "~/Shadow";
import { Time } from "~/Time";

import {
  DriverSummary,
  DriverSummary as DriverSummary_,
} from "./DriverSummary";

import * as MapBox from "./MapBox";
import { OverallSummary } from "./OverallSummary";

export function Dashboard() {
  return (
    <Dashboard.Container>
      <DriverSummary />
      <OverallSummary />
      <MapBox.MapboxMap.Component />
    </Dashboard.Container>
  );
}

export namespace Dashboard {
  export import DriverSummary = DriverSummary_;

  export namespace Route {
    export const definition = () => "/fleet" as const;
    export const href = () => definition();
    export const use = () => GenericRoute.use(href());
  }

  export namespace Interval {
    export const initial = (days?: number): Time.Interval.Stopped => {
      const now = Time.DateTime.now();
      const start = {
        dateTime: now.dateTime - Time.Duration.days(days ?? 7).duration,
      };
      return {
        interval: {
          start: Time.DateTime.toStartOfDayForZone(start),
          stop: Time.DateTime.toEndOfDayForZone(now),
        },
      };
    };

    export const use = () => React.useState(initial())[0];
  }

  export const Container = styled.div`
    position: relative;
    min-width: 1500px;
    min-height: 800px;
    height: 100%;
  `;

  export const Row = styled(Layout.Row.Component)`
    & > div {
      border-right: 1px solid ${() => Color.veryWhiteGrey()};
      &:last-of-type {
        border-right: none;
      }
    }
  `;

  export const Section = styled(Layout.Section.Component)`
    position: absolute;
    left: ${Layout.Page.padding};
    right: ${Layout.Page.padding};
    z-index: 2;

    box-shadow: ${Shadow.Box.style(Shadow.overAnImage())};

    &:nth-of-type(1) {
      top: ${Layout.Page.padding};
    }

    &:nth-of-type(2) {
      bottom: ${Layout.Page.padding};
    }
  `;
}
